async function themeComponent(url, async=true, checkDom=false) {
  if(url == undefined || url == null){
    // se l'url non è definito
    return;
  }
  const tagName = url.replace(/.*\//, '').replace(/\?.*/, '').replace('cmp-', '').replace('.js', '');
  // camelizza il nome del tag e metti in maiuscolo la prima lettera
  const className = tagName.replace(/-([a-z])/g, (g) => g[1].toUpperCase()).replace(/^./, (g) => g.toUpperCase());
  
  // se il tag è già definito non lo carico
  if(!window[className] == undefined){
    return;
  }

  // se devo controllare il dom e non trovo il tag non lo carico
  if(checkDom && document.querySelector(tagName) == null){
    return;
  }
  
  if(async){
    import(url).catch(e => {
      console.error(`Errore nel caricamento del componente ${tagName}:`, e);
    });
  } else {
    await import(url);
  }
}
window.themeComponent = themeComponent;

for (const key of Object.keys(theme.resources)) {
  themeComponent(theme.resources[key], false);
}
for (const key of Object.keys(theme.components)) {
  themeComponent(theme.components[key], false);
}

// attivo i popover di bootstrap
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

class McImage extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const img = this.querySelector('img');
    if(img.complete){
      this.classList.add('loaded');
      return;
    };
    img.addEventListener('load', () => {
      this.classList.add('loaded');
    });
  }
}
customElements.define('mc-image', McImage);